"use strict";
import {http} from '../../core';
import Config from "../../app.config";
const RequestService = http.create();
const RequestbaseURL = http.create({baseURL:Config.BASEURL});
export default {
    //资源申请列表
    getResourceApplyList(params){
        return RequestService.get('resource_appl/list',params)
    },

    //资源类型属性列表
    getResourceTypeAttr(params){
        return RequestService.get('resource_appl/resource_type_attr/list',params)
    },
    //创建资源申请
    resourceApplyAdd(params){
        return RequestService.post('resource_appl/add',params)
    },
    //资源申请详情
    getResourceApplyDetail(params){
        return RequestService.get('resource_appl/detail',params)
    },
    //删除资源申请
    deleteResourceApply(params){
        return RequestService.post('resource_appl/delete',params)
    },
    //编辑资源申请
    resourceApplyEdit(params){
        return RequestService.post('resource_appl/edit',params)
    },
    // 各操作流转
    resourceApplyHandle(params){
        return RequestService.post('resource_appl/handle',params)
    },
    //
    // // 繁忙度统计---人员繁忙度
    // busynessUser:function (userId) {
    //     return RequestbaseURL.get("itsm/v2/organization/user/busyness",{ internalUserid:userId })
    // },
    // //巡检日历
    // inspectionCalendar:function (params) {
    //     return RequestService.get('task/mycanlendar',params)
    //
    // }
}
